export enum WabaProvider {
    META = 'META',
    FIRE_MOBILE = 'FIRE_MOBILE',
    NUBITEL = 'NUBITEL'
}
